<template>
  <div class="tw-flex tw-flex-col tw-gap-1">
    <input
      ref="address"
      :value="address"
      :placeholder="$t('Address')"
      required="required"
      :name="addressInputName"
      type="text"
      class="form-control f-14"
      @input="$emit('update:address', $event.target.value)"
    />

    <div class="tw-flex tw-flex-row tw-gap-1">
      <input
        :value="city"
        :placeholder="$t('City')"
        required="required"
        :name="cityInputName"
        type="text"
        class="form-control f-14"
        @input="$emit('update:city', $event.target.value)"
      />

      <input
        v-if="countryHasPostcode"
        :value="postcode"
        :placeholder="postCodePlaceholder"
        required="required"
        :name="zipcodeInputName"
        type="text"
        class="form-control f-14"
        @input="$emit('update:postcode', $event.target.value)"
      />
    </div>

    <select
      :value="country"
      class="form-control f-14"
      :name="countryInputName"
      @input="$emit('update:country', $event.target.value)"
    >
      <option value="">{{ $t('Select country') }}</option>
      <option v-for="_country in getCountries" :key="_country.value" :value="_country.value">
        {{ _country.label }}
      </option>
    </select>

    <select
      v-if="countryHasStates"
      :value="state"
      class="form-control f-14"
      :name="stateInputName"
      @input="$emit('update:state', $event.target.value)"
    >
      <option value="">{{ $t('Select state') }}</option>
      <option v-for="_state in getStates" :key="_state.value" :value="_state.value">
        {{ _state.label }}
      </option>
    </select>
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue'

import { $t } from '@/app-bootstrapping/SetUpInternationalization'

import { useLocation } from '@/composables/useLocation'

const props = defineProps({
  address: {
    type: String,
    required: false,
    default: '',
  },

  city: {
    type: String,
    required: false,
    default: '',
  },

  postcode: {
    type: String,
    required: false,
    default: '',
  },

  country: {
    type: String,
    required: false,
    default: '',
  },

  state: {
    type: String,
    required: false,
    default: '',
  },

  addressInputName: {
    type: String,
    required: false,
    default: 'meta[address]',
  },

  cityInputName: {
    type: String,
    required: false,
    default: 'meta[city]',
  },

  zipcodeInputName: {
    type: String,
    required: false,
    default: 'meta[zipcode]',
  },

  countryInputName: {
    type: String,
    required: false,
    default: 'meta[country]',
  },

  stateInputName: {
    type: String,
    required: false,
    default: 'meta[state]',
  },
})

defineEmits(['update:address', 'update:city', 'update:postcode', 'update:country', 'update:state'])

const {
  getCountries,
  getStates,
  setSelectedCountry,
  setSelectedState,
  postCodePlaceholder,
  countryHasStates,
  countryHasPostcode,
} = useLocation()

onMounted(() => {
  setSelectedCountry(props.country?.toUpperCase() ?? '')
  setSelectedState(props.state?.toUpperCase() ?? '')
})

watch(
  () => props.country,
  (country) => {
    setSelectedCountry(country?.toUpperCase() ?? '')
  },
)

watch(
  () => props.state,
  (state) => {
    setSelectedState(state?.toUpperCase() ?? '')
  },
)
</script>
